import { inClass } from "../../../../../utils/Helpers";

/** Clears inline drop-preview shadows from every builder component (see handleDragOverPos). */
function clearAllBuilderDragPreviewStyles(): void {
  document.querySelectorAll(".builder-component").forEach((node) => {
    const el = node as HTMLElement;
    el.classList.remove("dragover");
    el.style.webkitBoxShadow = "";
    el.style.boxShadow = "";
    el.style.setProperty("-moz-box-shadow", "");
    el.style.removeProperty("transition");

    const first = el.firstElementChild as HTMLElement | null;
    if (
      el.getAttribute("data-component-type") === "image" &&
      first?.classList.contains("builder-image--loaded")
    ) {
      first.style.webkitBoxShadow = "";
      first.style.boxShadow = "";
      first.style.setProperty("-moz-box-shadow", "");
      first.style.removeProperty("transition");
    }
  });
}

export const handleDragEnd = (e, ref) => {
  const builderElement = inClass("builder-component--active", ref.current);
  builderElement?.setAttribute("draggable", "false");
  clearAllBuilderDragPreviewStyles();
};
